import { FC, useEffect, useState } from 'react'
import LevelApi from '../../../../infrastructure/api/LevelApi'
import { ILevelModel } from '../../../../models/responses/LevelModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const LevelListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [levels, setLevels] = useState<PagedResponseModel<ILevelModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('difficulty_asc')

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    async function getLevels() {
      var response = await LevelApi.GetLevels(paginationFilter)
      setLevels(response.data)
    }
    getLevels()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Levels'
        data={levels?.items}
        currentTotalRecords={levels?.totalRecords!!}
        currentPageNumber={levels?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false
            },
          },
          {
            label: 'Name',
            name: 'name',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
            },
          },
          { label: 'Difficulty', name: 'difficulty' },
          { label: 'Group', name: 'levelGroupTitle', options: { sort: false } },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={levels?.items[dataIndex]?.id!!}
                    itemParam={levels?.items[dataIndex]?.name!!}
                    types={[TableHelperButtonEnum.Update, TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { LevelListModal }
